<header class="header-container main-header new-header-border {{customClass}}">
  <mat-toolbar class="header--main-toolbar p-0!">
    <div class="container max-w-full! w-full!" id="top-header-container">
      <div class="flex flex-row justify-between navigation-container">
        <div class="flex flex-row lg:gap-4 items-center gray-color">
          <pin-logo [type]="logoType"></pin-logo>
          @if (displaySessionDetails) {
            <pin-bank-logo [bankName]="bankName" [bankCustomizationData]="bankCustomizationData"></pin-bank-logo>
          }
        </div>

        @if (displaySessionDetails) {
          <nav class="flex flex-row main-navigation" role="navigation" aria-label="user account buttons">
            <button matButton class="actions-button h-auto!" id="actions-button" [matMenuTriggerFor]="actionsMenu">
              <mat-icon aria-hidden="true" class="menu-icon md-20 -mr-2! lg:mr-2!">menu</mat-icon>
              <span class="actions-text body-md-regular color-content-subtle text-nowrap-ellipsis no-print hidden lg:inline lg:ml-2">ACTIONS</span>
            </button>

            <button matButton class="actions-button-mobile" (click)="openMenu()">
              <mat-icon aria-hidden="true" class="md-20 mx-0!">menu</mat-icon>
            </button>

            <button matButton #profileMenuTrigger="matMenuTrigger" class="profile-button h-auto!" id="profile-button" [matMenuTriggerFor]="profileMenu">
              <span class="header-button-text-wrapper">
                <mat-icon aria-hidden="true" class="person-icon md-20">person</mat-icon>
                <span id="header-customer-name" class="header-customer-name inline-block uppercase text-nowrap-ellipsis body-md-regular color-content-subtle">{{ displayName }}</span>
                <mat-icon aria-hidden="true" class="menu-trigger-icon md-20">{{profileMenuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
              </span>
            </button>

            <mat-menu #actionsMenu="matMenu" class="actions-menu header-menu max-w-90!">
              <button mat-menu-item class="header-menu" data-testid="where-can-my-funds-be-placed-menu-item" [routerLink]="['/where-can-my-funds-be-placed']">WHERE CAN MY FUNDS BE PLACED?</button>
              @if (hasCustomerLevelAccess && !ssoUser) {
                <button mat-menu-item class="header-menu" data-testid="manage-account-access-menu-item" [routerLink]="['/manage-access']">MANAGE ACCOUNT ACCESS</button>
              }
            </mat-menu>

            <mat-menu #profileMenu="matMenu" class="profile-menu header-menu">
              @if (!ssoUser) {
              <button mat-menu-item class="header-menu" data-testid="my-profile-settings-menu-item" [routerLink]="[internalRoutes.MY_PROFILE]">MY PROFILE SETTINGS</button>
              }
              <button mat-menu-item id="logout-button" data-testid="logout-button" class="btn-logout header-menu" i18n="@@header.logout" [routerLink]="['/logout']" fragment="ssoLogout">
                <mat-icon aria-hidden="true" class="md-20">logout</mat-icon>LOG OUT
              </button>
            </mat-menu>
          </nav>
        }
      </div>
    </div>
  </mat-toolbar>
</header>
